import appUtils from '../../utils/appUtils';
import { guessTimezone } from '../../lib/date-utils';

import {
  GET_GEODATA_SUCCEEDED,
  GET_GEODATA_FAILED,
  SET_GEODATA,
} from '../../actions/geoData';

const initialState = {
  geoData: {
    ip: null,
    countryCode: null,
    timeZone: guessTimezone(),
  },
  getGeoDataFailedCount: 0,
  getGeoDataFailed: false,
};

export default function geoDataReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case SET_GEODATA:
      return {
        ...state,
        geoData: {
          ip: appUtils.isNull(payload.ip) ? state.geoData.ip : payload.ip,
          countryCode: appUtils.isNull(payload.countryCode)
            ? state.geoData.countryCode
            : payload.countryCode,
          timeZone: payload.timeZone,
        },
      };
    case GET_GEODATA_SUCCEEDED:
      return {
        ...state,
        geoData: {
          ip: payload.ip,
          countryCode: payload.country_code,
          timeZone: payload.timezone,
        },
        getGeoDataFailedCount: 0,
        getGeoDataFailed: false,
      };
    case GET_GEODATA_FAILED:
      return {
        ...state,
        getGeoDataFailedCount: state.getGeoDataFailedCount + 1,
        getGeoDataFailed: true,
      };
    default:
      return state;
  }
}
